import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/esnext.global-this.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useContext, useEffect } from 'react';
import { Container, Grid, Box, FacilityActions, FacilityContext, TAGTypography, TAGSvgIcon, TAGLink, TAGPhoneDrawer, // ReviewsModal,
RichText, useMediaQuery, TAGButton } from '../../..';

var FacilityHero = function FacilityHero(_ref) {
  var callCenterHours = _ref.callCenterHours,
      callCenterText = _ref.callCenterText,
      callCenterTextMobile = _ref.callCenterTextMobile,
      callCenterTextPhoneDrawer = _ref.callCenterTextPhoneDrawer,
      facilityData = _ref.facilityData,
      heroLargeText = _ref.heroLargeText,
      image = _ref.image,
      officeHoursBtnText = _ref.officeHoursBtnText,
      officeHoursText = _ref.officeHoursText,
      officeName = _ref.officeName,
      scheduleBtnText = _ref.scheduleBtnText,
      scheduleBtnUrl = _ref.scheduleBtnUrl;
  var days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

  var _useContext = useContext(FacilityContext),
      dispatchFacilityAction = _useContext.dispatch,
      facilityState = _useContext.state;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  var toggleOpen = function toggleOpen() {
    setOpen(!open);
  };

  var mobileWidth = useMediaQuery('(max-width:768px)');

  if (facilityData.address == null) {
    return null;
  }

  useEffect(function () {
    if (facilityState.code !== facilityData.code) {
      var _globalThis$localStor;

      dispatchFacilityAction(FacilityActions.setFacilityInfoAction(_objectSpread(_objectSpread({}, facilityData), {}, {
        alerts: [],
        distance: Math.round(facilityData.distance)
      })));
      (_globalThis$localStor = globalThis.localStorage) === null || _globalThis$localStor === void 0 ? void 0 : _globalThis$localStor.setItem('facility', facilityData.code);
    }
  });

  function formatPhoneNumber(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

    if (match) {
      return "(".concat(match[1], ") ").concat(match[2], "-").concat(match[3]);
    }

    return null;
  }

  var renderOfficeWorkHours = function renderOfficeWorkHours() {
    return React.createElement(Grid, {
      container: true,
      columnSpacing: 3,
      rowSpacing: 1,
      alignItems: "center",
      sx: {
        pb: mobileWidth ? '25px' : 0
      }
    }, React.createElement(Grid, {
      item: true
    }, React.createElement(TAGTypography, {
      variant: "bodyMediumSemiBold",
      color: 'primary',
      sx: {
        display: 'block',
        fontSize: {
          xs: '22px',
          sm: '16px'
        },
        lineHeight: {
          xs: '28px',
          sm: '24px'
        },
        p: mobileWidth && '18px 30px 7px'
      }
    }, officeHoursText)), React.createElement(Grid, {
      item: true
    }, React.createElement(Grid, {
      container: true,
      columnSpacing: 3,
      rowSpacing: 1
    }, days.map(function (d, i) {
      return React.createElement(Grid, {
        item: true,
        key: i,
        sx: {
          display: mobileWidth ? 'flex' : 'block'
        }
      }, React.createElement(TAGTypography, {
        variant: "bodySmallBook",
        color: 'text.primary',
        sx: {
          display: 'block',
          fontSize: {
            xs: '16px',
            sm: '14px'
          },
          lineHeight: {
            xs: '24px',
            sm: '20px'
          },
          pl: mobileWidth && '30px',
          width: mobileWidth && '110px'
        }
      }, d), React.createElement(TAGTypography, {
        variant: "bodySmallBook",
        color: 'text.secondary',
        sx: {
          display: 'block',
          fontSize: {
            xs: '16px',
            sm: '14px'
          },
          lineHeight: {
            xs: '24px',
            sm: '24px'
          },
          pr: mobileWidth && '30px'
        }
      }, facilityData.workingHours[d] != null ? facilityData.workingHours[d] : 'Closed'));
    }))));
  };

  var renderCallCenterHours = function renderCallCenterHours() {
    return React.createElement(Grid, {
      container: true,
      sx: {
        mb: mobileWidth ? '32px' : '8px'
      }
    }, callCenterHours.map(function (d, i) {
      return React.createElement(Grid, {
        container: true,
        key: i,
        sx: {
          pb: mobileWidth ? '8px' : 0
        }
      }, React.createElement(Grid, {
        item: true
      }, React.createElement(TAGTypography, {
        variant: "bodyMediumBook",
        color: 'text.primary',
        sx: {
          display: 'block',
          fontSize: {
            xs: '16px',
            sm: '16px'
          },
          lineHeight: {
            xs: '24px',
            sm: '24px'
          },
          width: mobileWidth ? '110px' : '80px',
          pl: mobileWidth && '30px'
        }
      }, d.day)), React.createElement(Grid, {
        item: true
      }, React.createElement(TAGTypography, {
        variant: "bodyMediumBook",
        color: 'text.secondary',
        sx: {
          display: 'block',
          fontSize: {
            xs: '16px',
            sm: '16px'
          },
          lineHeight: {
            xs: '24px',
            sm: '24px'
          }
        }
      }, d.hours)));
    }));
  };

  return React.createElement(React.Fragment, null, React.createElement(Grid, {
    container: true
  }, React.createElement(Container, {
    sx: {
      p: mobileWidth ? 0 : '24px'
    }
  }, React.createElement(Grid, {
    container: true,
    sx: {
      mb: '20px',
      p: mobileWidth ? '15px' : '0px'
    },
    flexDirection: "column"
  }, React.createElement(TAGTypography, {
    variant: "h1",
    color: 'text.primary',
    sx: {
      mb: '8px',
      fontSize: {
        xs: '29px',
        md: '38px'
      },
      lineHeight: {
        xs: '36px',
        md: '48px'
      }
    }
  }, facilityData.name)), React.createElement(Grid, {
    container: true,
    sx: {
      mb: '4px'
    },
    direction: mobileWidth ? 'column-reverse' : 'row'
  }, React.createElement(Grid, {
    item: true,
    xs: 4
  }, React.createElement(Grid, {
    item: true,
    sx: {
      mb: mobileWidth ? 0 : '4px',
      mr: mobileWidth ? 0 : '4px',
      backgroundColor: 'primary.light',
      p: mobileWidth ? '20px 20px 0' : '25px 24px',
      textAlign: mobileWidth ? 'center' : 'left'
    }
  }, React.createElement(TAGTypography, {
    variant: mobileWidth ? 'bodySmallSemiBold' : 'bodyLargeBook',
    color: 'text.primary',
    sx: {
      display: 'block',
      fontSize: {
        xs: '16px',
        md: '18px'
      },
      lineHeight: {
        xs: '20px',
        md: '28px'
      },
      mb: '4px'
    }
  }, officeName), React.createElement(TAGLink, {
    href: "https://www.google.com/maps/dir//".concat(facilityData.latitude, ",").concat(facilityData.longitude)
  }, React.createElement(TAGTypography, {
    variant: mobileWidth ? 'bodySmallBook' : 'bodyMediumSemiBold',
    color: mobileWidth ? 'primary.main' : 'secondary.main',
    sx: {
      display: 'block',
      fontSize: {
        xs: '14px',
        sm: '18px'
      },
      lineHeight: {
        xs: '20px',
        sm: '24px'
      },
      mb: mobileWidth ? 0 : '4px'
    }
  }, facilityData.address.line1, React.createElement("br", null), " ", facilityData.address.city, ", ", facilityData.address.state, " ", facilityData.address.zipCode))), React.createElement(Grid, {
    item: true,
    sx: {
      mr: mobileWidth ? 0 : '4px',
      backgroundColor: 'primary.light',
      p: '16px 24px',
      textAlign: mobileWidth ? 'center' : 'left'
    }
  }, React.createElement(TAGTypography, {
    variant: mobileWidth ? 'bodySmallBold' : 'bodyMediumSemiBold',
    color: mobileWidth ? 'text.secondary' : 'text.primary',
    sx: {
      display: 'block',
      fontSize: {
        xs: '12px',
        sm: '16px'
      },
      lineHeight: {
        xs: '16px',
        sm: '24px'
      },
      mb: '4px'
    }
  }, mobileWidth ? callCenterTextMobile : callCenterText), !mobileWidth && renderCallCenterHours(), React.createElement(Grid, {
    container: true
  }, React.createElement(TAGLink, {
    href: "tel:".concat(facilityData.phoneNumber),
    sx: {
      width: mobileWidth ? '100%' : 'auto',
      display: mobileWidth ? 'flex' : 'inline-block',
      justifyContent: 'center'
    }
  }, React.createElement(Grid, {
    container: true
  }, !mobileWidth && React.createElement(TAGSvgIcon, {
    icon: "Mobile",
    size: 28
  }), React.createElement(TAGTypography, {
    variant: "bodyLargeBold",
    color: mobileWidth ? 'secondary.main' : 'text.primary',
    sx: {
      display: mobileWidth ? 'flex' : 'inline-block',
      justifyContent: 'center',
      fontSize: {
        xs: '16px',
        sm: '18px'
      },
      lineHeight: {
        xs: '24px',
        sm: '28px'
      },
      mb: '4px',
      width: mobileWidth ? '100%' : 'auto'
    }
  }, formatPhoneNumber(facilityData.phoneNumber))))), mobileWidth && React.createElement(TAGButton, {
    onClick: toggleOpen,
    buttonVariant: "Primary Default"
  }, officeHoursBtnText))), React.createElement(Grid, {
    container: true,
    xs: mobileWidth ? 12 : 8,
    alignItems: "center",
    sx: {
      backgroundColor: 'neutrals.primary',
      backgroundImage: "url(".concat(image === null || image === void 0 ? void 0 : image.url, ")"),
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover'
    }
  }, React.createElement(Grid, {
    item: true,
    sx: {
      p: mobileWidth ? '24px 15px 21px' : '20px 53px 18px',
      width: '100%'
    }
  }, React.createElement(Grid, {
    sx: {
      display: 'block',
      fontSize: {
        xs: '41px',
        sm: '64px'
      },
      lineHeight: {
        xs: '48px',
        sm: '80px'
      },
      mb: {
        xs: '20px',
        sm: '32px'
      },
      '& .MuiGrid-root': {
        background: 'transparent'
      },
      '& h1, h2, h3, h4,h5, h6': {
        m: 0,
        lineHeight: mobileWidth ? '48px' : '80px',
        fontSize: mobileWidth ? '41px' : '64px'
      }
    }
  }, React.createElement(RichText, _objectSpread({}, heroLargeText))), React.createElement(TAGButton, {
    buttonVariant: "Primary Default",
    sx: {
      width: {
        xs: '100%',
        sm: '100%',
        md: 'auto'
      },
      display: 'inline-block',
      textAlign: 'center'
    },
    href: "".concat(scheduleBtnUrl).concat(facilityData.code)
  }, scheduleBtnText)))), !mobileWidth && React.createElement(Grid, {
    container: true,
    sx: {
      backgroundColor: 'primary.light',
      alignItems: 'center',
      p: '7px 24px'
    }
  }, renderOfficeWorkHours()), mobileWidth && React.createElement(TAGPhoneDrawer, {
    open: open,
    onOpen: toggleOpen,
    onClose: toggleOpen
  }, renderOfficeWorkHours(), React.createElement(Grid, {
    item: true
  }, React.createElement(TAGTypography, {
    variant: "bodyMediumSemiBold",
    color: 'primary',
    sx: {
      display: 'block',
      fontSize: {
        xs: '22px',
        sm: '16px'
      },
      lineHeight: {
        xs: '28px',
        sm: '24px'
      },
      p: mobileWidth && '0 30px 15px'
    }
  }, callCenterTextPhoneDrawer)), renderCallCenterHours(), React.createElement(Box, {
    sx: {
      p: mobileWidth ? '0 30px 30px' : 0
    }
  }, React.createElement(TAGButton, {
    buttonVariant: "Secondary Default",
    sx: {
      width: {
        xs: '100%',
        sm: 'auto',
        md: 'auto'
      }
    },
    href: "tel:".concat(facilityData.phoneNumber)
  }, "CALL ".concat(formatPhoneNumber(facilityData.phoneNumber))))))));
};

export default FacilityHero;